import IService from "./service";
import LoadingService from "./modals/loading.service";
import AlertsService from "./modals/alerts.service";

export default class ModalsService extends IService {
    constructor(provider, config) {
        super(provider, config);
        this.instances = {};
    }

    /**
     * Create instance of a service
     * @param name {string}
     * @param type {Function}
     * @returns {*}
     */
    instantiate(name, type) {
        if (typeof this.instances[name] === 'undefined') {
            let config = typeof this.config[name] === 'undefined'
                ? {}
                : this.config[name];
            config.repositories = this.config.repositories;
            this.instances[name] = new type(this.$services, config);
        }
        return this.instances[name];
    }

    /**
     * Getter
     * @returns {LoadingService}
     */
    get loading() {
        return this.instantiate(
            'loading',
            LoadingService
        );
    }

    /**
     * Getter
     * @returns {AlertsService}
     */
    get alerts() {
        return this.instantiate(
            'alerts',
            AlertsService
        );
    }

    /**
     * Getter
     * @returns {ModalsService}
     */
    get modals() {
        return this.instantiate(
            'modals',
            ModalsService
        );
    }
}